import Pendo from './Pendo';

export default Pendo;
